export var UserLevel;
(function (UserLevel) {
    UserLevel[UserLevel["user"] = 3] = "user";
    UserLevel[UserLevel["kernel"] = 0] = "kernel";
})(UserLevel || (UserLevel = {}));
export var UserCategory;
(function (UserCategory) {
    UserCategory[UserCategory["universe"] = 0] = "universe";
    UserCategory[UserCategory["algo"] = 1] = "algo";
    UserCategory[UserCategory["clang"] = 2] = "clang";
    UserCategory[UserCategory["pylang"] = 3] = "pylang";
})(UserCategory || (UserCategory = {}));
export let login = false;
export let identity = null;
export function initialize(user) {
    login = true;
    identity = user;
}
export function is_admin() {
    return identity !== null && identity.level <= UserLevel.kernel;
}



// WEBPACK FOOTER //
// ./src/user-service.ts